export const en = {
    autoProlongation: 'Autoextend period',
    avgBid: 'average weekly click price',
    avgBidOpt: 'average weekly CPC',
    avgCpa: 'average weekly conversion price',
    avgCpaOpt: 'Average weekly CPA',
    avgCpi: 'average cost per app install',
    avgCpm: 'average CPM',
    bid: 'maximum weekly click price',
    'by-all-key-goals': 'For all priority goals',
    clicksLimit: 'number of weekly clicks',
    'day-budget-sum': 'budget amount',
    default: 'Standard',
    filterAvgBid: 'Weekly CPC for each filter',
    filterAvgCpa: 'Weekly CPA for each filter',
    finish: 'end of period',
    'fixed-cpm': 'todo',
    maxCpa: 'maximum conversion rate',
    'maximum-number-impressions': 'Maximize impressions for lowest price',
    'nedelnyy-byudzhet': 'Weekly budget',
    'nedelnyy-paket-klikov': 'Weekly click package',
    'on-both-platforms': 'on all sites',
    'on-net-platform': 'in ad networks',
    'on-search-platform': 'on search',
    'optimizaciya-kolichestva-klikov-per-camp': 'Optimizing the number of clicks per campaign',
    'optimizaciya-kolichestva-klikov-per-filter': 'Optimize number of clicks by each filter',
    'optimizaciya-kolichestva-konversiy-per-camp': 'Optimize number of conversion by campaign',
    'optimizaciya-kolichestva-konversiy-per-filter': 'Optimize number of conversions by each filter',
    'optimize-clicks': 'Optimize clicks',
    'optimize-cpa': 'Conversion optimization',
    'optimize-cpi': 'Optimize number of app installations',
    'po-vsem-tselyam': 'For all goals',
    profitability: "revenue amounts to product or service's production costs",
    profitabilityValue: '{profitability}%',
    reserveReturn: 'of savings to be reinvested into campaign',
    reserveReturnValue: '{reserveReturn}%',
    roi: 'Optimize ROI',
    roiCoef: 'average weekly ROI',
    'ruchnoe-upravlenie-stavkami': 'Manual bid management',
    'ruchnoe-upravlenie-stavkami-generic': 'Manual bid management (with optimization in ad networks)',
    'ruchnoe-upravlenie-stavkami-generic2': 'Manual bid management (with optimization)',
    'ruchnoe-upravlenie-stavkami-s-optimizaciei': 'Manual management with optimization in ad networks',
    'ruchnoe-upravlenie-stavkami2': 'Manual bid management with optimization',
    separateBidding: 'Separately manage bids on search and on networks',
    showMode: 'display mode',
    'snizhenie-tseny-povtornyh-pokazov': 'Decrease price for repeat impressions',
    'srednyaya-cena-klika': 'Average CPC',
    'srednyaya-cena-konversii': 'Average CPA',
    'srednyaya-cena-ustanovki-prilozheniya': 'Average CPI',
    start: 'start of period',
    stretched: 'Distributed',
    sum: 'weekly budget',
    tsel: 'Goal "{goalName}"',
    'vse-tseli': 'All goals',
    'week-budget-max-clicks': 'Maximum number of clicks',
    'week-budget-max-installations': 'Maximum number of installations'
};
